import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

export function createMultiselectFieldValidationSuite(
  definition: MultiselectField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue) as {
    value: string;
    label: string;
  }[];

  if (definition.required) {
    test(
      createFieldName(definition),
      trans("form_validation.multiselect.required"),
      () => {
        enforce(value).isNotEmpty();
      },
    );
  }
}
